import script from "./MaCollectiviteEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaCollectiviteEdit.vue?vue&type=script&setup=true&lang=ts"

import "./MaCollectiviteEdit.vue?vue&type=style&index=0&id=09038917&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09038917"]])

export default __exports__